import {SeedEntity} from "@/declares/entity/SeedEntity";


export class PayRecordDO extends SeedEntity {
  flowNo: string = '';
  tradeNo: string = '';
  appId: string = '';
  bizNo: string = '';
  mchCode: string = '';
  money: number = null as any;
  remark: string = '';
  userId: string = '';
  status: number = null as any;
  payType: number = null as any;
  subType: number = null as any;
  gmtExpire: Date = null as any;
  reqBody: string = '';
  unifiedOrderReqBody: string = '';
  unifiedOrderResBody: string = '';
  gmtNotify: Date = null as any;
  notifyBody: string = '';
  gmtLastNotifyBiz: Date = null as any;
  lastNotifyBizType: number = null as any;
  lastNotifyBizNo: string = '';
  lastNotifyBizStatus: number = null as any;
  lastNotifyBizError: string = '';
}
